import React, { memo } from 'react';
import classnames from 'classnames';
import TickIcon from 'images/icons/tick-accepted.svg';
import './Tab.scss';

const Tab = ({ name = '', active = false, done = false }) => {
  const classes = classnames('Tab', {
    active,
    done,
  });

  return (
    <div className={classes}>
      {done && <TickIcon className="Tab__icon" viewBox="0 0 24 24" />}
      <span className="Tab__text">{name}</span>
    </div>
  );
};

export default memo(Tab);
